<template>
  <a-layout class="h-100">
    <a-layout-header
      class="bg-white"
      style="border-bottom: 1px solid #eeeeee;display: flex;align-items: center;justify-content: space-between"
    >
      <span style="font-weight: bolder;">{{ $t('permission.title') }}</span>
      <a-space>
        <a-button style="margin: 10px" key="back" @click="routeBack">{{ $t('buttons.goBack') }}</a-button>
        <a-button style="float: right" type="primary" @click="saveRole">{{ $t('buttons.save') }}</a-button>
        <a-button style="margin: 10px" @click="showClipboard">{{ $t('role.clipboard') }}</a-button>
      </a-space>
    </a-layout-header>
    <a-layout style="height: 100%;">
      <!-- <a-layout-sider style="min-width: 245px" class="bg-white">
        <a-menu style="width: 100%;height: 96%" mode="inline" theme="light" v-model="currentRole" @click="clickMenuItem">
          <a-menu-item class="role-item" v-for="role in roleList" :key="role.id">
            {{ role['zh-CN'] }}
            <div :style="{ display: currentRole[0] === role.id ? 'inline-block' : 'none' }" class="role-item-option">
              <a-icon type="form" @click="showRoleModal(role, true)"/>
              <a-icon type="delete" @click="deleteRole(role.id)"/>
            </div>
          </a-menu-item>
          <menu-item :menus="roleList" />
        </a-menu>
        <a-menu
          style="height: 95%; padding-bottom: 15px"
          mode="inline"
        >
          <template v-for="role in roleList">
            <menu-item class="role-item" :key="role.id" :menuItem="role" />
          </template>
          <menu-item class="role-item" v-for="role in roleList" :key="role.id" :menuItem="role" />
        </a-menu>
        <a-input-search style="margin-bottom: 8px" placeholder="Search" v-model="searchRoleValue" />
        <a-tree
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="roleList"
        >
          <template slot="title" slot-scope="scope">
            <span v-if="title.indexOf(searchRoleValue) > -1">
              {{ title.substr(0, title.indexOf(searchRoleValue)) }}
              <span style="color: #f50">{{ searchRoleValue }}</span>
              {{ title.substr(title.indexOf(searchRoleValue) + searchRoleValue.length) }}
            </span>
            <span>{{ scope.dataRef['zh-CN'] }}</span>
          </template>
        </a-tree>
        <div style="padding: 0 20px;border-right: 1px solid #e8e8e8;height: 4%;display: flex;align-items: center">
          <a-button type="link" icon="usergroup-add" block @click="showRoleModal({}, false)">
            新增角色
          </a-button>
        </div>
      </a-layout-sider>-->
      <a-form-model
        layout="inline"
        ref="form"
        style="padding: 30px 30px 0; display: flex; justify-content: space-between"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item :style="{ width: lang === 'en' ? '270px' : '240px' }" :label="$t('permission.pRole')" prop="pid">
          <a-select
            v-model="form.pid"
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            style="width: 140px"
          >
            <a-select-option v-for="(value, key) in pids" :key="key" :value="key">{{ value }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :style="{ width: lang === 'en' ? '246px' : '196px' }" :label="$t('permission.name')" prop="zh-CN">
          <a-input style="width: 96px" v-model="form['zh-CN']" />
        </a-form-model-item>
        <a-form-model-item :label="$t('role.columns.privilegeLevel')" prop="privilegeLevel" :style="{ width: lang === 'en' ? '170px' : '140px' }">
          <a-input style="width: 50px" v-model="form.privilegeLevel" />
        </a-form-model-item>
        <a-form-model-item :style="{ width: lang === 'en' ? '265px' : '211px' }" :label="$t('permission.dataScope')" prop="dataScope">
          <a-select
            v-model="form.dataScope"
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            style="width: 130px"
          >
            <a-select-option value="0">{{ $t('common.all') }}</a-select-option>
            <a-select-option value="1">{{ $t('permission.to') }}</a-select-option>
            <a-select-option value="2" :title="lang === 'en' ? $t('permission.tois') : ''">{{ $t('permission.tois') }}</a-select-option>
            <a-select-option value="3">{{ $t('permission.s') }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :style="{ width: lang === 'en' ? '320px' : '511px' }" :label="$t('permission.dt')">
          <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            :style="{ width: lang === 'en' ? '200px' : '420px' }"
            mode="tags"
            :placeholder="$t('placeholder.t')"
            v-model="form.allowSelectDeviceType"
          >
            <a-select-option v-for="i in deviceTypeList" :key="i.id" :value="i.value">{{ i.text }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('permission.e')">
          <a-checkbox :checked="form.isSelfStation" @change="handleSelfStationChange" />
        </a-form-model-item>
        <a-form-model-item :label="$t('role.columns.enabled')">
          <a-switch v-model="form.enabled" />
        </a-form-model-item>
      </a-form-model>
      <a-form-model style="padding: 0 30px; display: flex; justify-content: space-between">
        <a-form-model-item :label="$t('permission.userDataScope')">
          <a-radio-group name="userDataScope" v-model="form.userDataScope">
            <a-radio :value="0">是</a-radio>
            <a-radio :value="1">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <a-layout-content style="padding: 20px 18px">
        <!-- <a-collapse style="margin-bottom: 20px" default-active-key="1" expand-icon-position="right" v-for="(item, index) in permissionList" :key="item.menuName">
          <a-collapse-panel key="1">
            <div class="bg-white" slot="header" @click.stop="() => {}">
              <a-checkbox
                :indeterminate="item.indeterminate"
                :checked="item.checkAll"
                @change="(e) => onCheckAllChange(e, item, index)"
              >{{ item.menuName }}</a-checkbox>
            </div>
            <a-checkbox-group v-model="selectedPermission[index]" @change="(list) => onChange(list, item)">
              <a-checkbox v-for="permission in item.permissions" :key="permission.id" :value="permission.id">{{ permission.name }}</a-checkbox>
            </a-checkbox-group>
          </a-collapse-panel>
        </a-collapse>-->
        <a-checkbox
          :indeterminate="isOutestindeterminate"
          v-model="isOutestAllSelected"
          @change="handleSelectAllOut"
        >{{ $t('sa') }}</a-checkbox>
        <a-collapse
          v-model="activeKeys"
          expand-icon-position="right"
          v-for="outestMenu in menusList"
          :key="outestMenu.id"
        >
          <a-collapse-panel :key="outestMenu.id + ''">
            <div class="bg-white" slot="header">
              <a-checkbox
                :indeterminate="outestMenu.indeterminate"
                @change="handleOuterChange($event, outestMenu)"
                v-model="outestMenu.checked"
                @click.stop
              />
              <span style="margin-left: 8px">{{ outestMenu['zh-CN'] }} - {{ environmentMap[outestMenu.isMobile]}}</span>
            </div>
            <template v-if="!outestMenu.children || outestMenu.children.length === 0">
              <a-checkbox
                @change="handleAuthoritiesChange($event, outestMenu)"
                v-model="a.checked"
                v-for="a in outestMenu.authorities"
                :key="a.id"
              >{{ a['zh-CN'] }}</a-checkbox>
            </template>
            <template v-else>
              <a-collapse
                v-model="innerActiveKeys"
                expand-icon-position="right"
                v-for="outerMenu in outestMenu.children"
                :key="outerMenu.id + ''"
                style="margin-bottom: 20px"
              >
                <a-collapse-panel :key="outerMenu.id + ''">
                  <div class="bg-white" slot="header">
                    <a-checkbox
                      :indeterminate="outerMenu.indeterminate"
                      @change="handleChildrenMenuChange($event, outerMenu, outestMenu)"
                      v-model="outerMenu.checked"
                      @click.stop
                    />
                    <span style="margin-left: 8px">{{ outerMenu['zh-CN'] }} - {{ environmentMap[outerMenu.isMobile]}}</span>
                  </div>
                  <a-checkbox
                    @change="handleAuthoritiesChange($event, outerMenu, outestMenu)"
                    v-model="a.checked"
                    v-for="a in outerMenu.authorities"
                    :key="a.id"
                  >{{ a['zh-CN'] }}</a-checkbox>
                </a-collapse-panel>
              </a-collapse>
            </template>
          </a-collapse-panel>
          <!-- <a-collapse-panel key="1">
            <div class="bg-white" slot="header">
              <a-checkbox @click.stop="" />
              <span style="margin-left: 8px">{{ outestMenu['zh-CN'] }}</span>
            </div>
            <a-collapse default-active-key="4" expand-icon-position="right">
              <a-collapse-panel key="4">
                <div class="bg-white" slot="header">
                  <a-checkbox @click.stop="" />
                  <span style="margin-left: 8px">角色管理</span>
                </div>
                <a-checkbox-group>
                  <a-checkbox>增</a-checkbox>
                  <a-checkbox>删</a-checkbox>
                  <a-checkbox>改</a-checkbox>
                  <a-checkbox>查</a-checkbox>
                </a-checkbox-group>
              </a-collapse-panel>
            </a-collapse>
          </a-collapse-panel>-->
        </a-collapse>
      </a-layout-content>
    </a-layout>
    <a-modal title="角色" v-model="roleModal.visible" @ok="saveOrUpdateRole">
      <a-form-model
        ref="roleForm"
        :rules="roleModal.rules"
        layout="horizontal"
        :model="roleModal.role"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="名称" prop="name" required>
          <a-input v-model="roleModal.role.name" placeholder="请输入角色名称" />
        </a-form-model-item>
        <a-form-model-item label="角色编码" prop="code">
          <a-input v-model="roleModal.role.code" placeholder="请输入角色编码" autocomplete="off" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal @ok="isClipboardShow = false" :title="$t('role.clipboard')" v-model="isClipboardShow">
      <a-list item-layout="horizontal" :data-source="clipboardList">
        <a-list-item slot="renderItem" slot-scope="item">
          <div style="position: relative; width: 100%">
            {{ item.name }}
            <!-- <a-button :loading="loading1" style="padding-left: 0; margin-left: 20px" type="link" @click="importBasicInfo(item)">导入基础信息</a-button> -->
            <a-button :loading="item.loading" style="padding-left: 0;" type="link" @click="importAuth(item)">{{ $t('role.importAuth') }}</a-button>
            <!-- <a-button :loading="loading3" style="padding-left: 0;" type="link" @click="importAll(item)">导入全部</a-button> -->
            <a-icon @click="removeClip(item)" type="close" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); cursor: pointer" />
          </div>
        </a-list-item>
      </a-list>
    </a-modal>
  </a-layout>
</template>

<script>
import userApi from "@/api/user";
import {
  getRoleList,
  getRole,
  searchRoleList,
  addRole,
  updateRole,
  removeRole
} from "@/api/auth/role";
import { getDict } from "@/api/dict";
import { getMenuList, getAllMenuList } from "@/api/auth/menu";

export default {
  name: "index",
  created() {
    searchRoleList(1, 100, {
      query: [],
      filter: [],
      sort: []
    }).then(async res => {
      let l = [];
      if (res.data.total > 100) {
        const { data } = await searchRoleList(1, res.data.total);
        l = data.records;
      } else {
        l = res.data.records;
      }
      this.roleList = l;
      this.setName(this.roleList);
      this.getDictList();
      await this.getAllMenuList();
      if (this.$route.query.id) {
        this.getRoleInfo(this.$route.query.id);
      }
      if (this.$route.query.pid) {
        this.form.pid = this.$route.query.pid
      }
    });
  },
  data() {
    const checkRoleCode = (rule, value, callback) => {
      const reg = new RegExp(/^[\u4e00-\u9fa5a-zA-z0-9]+$/);
      if (!reg.test(value)) {
        callback(new Error("角色编码不能包含特殊字符"));
      } else {
        callback();
      }
    };
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      roleList: [],
      currentRole: [],
      permissionList: [],
      selectedPermission: [],
      roleModal: {
        isEdit: false,
        visible: false,
        role: {},
        rules: {
          name: [
            { required: true, message: "角色名称不能为空", trigger: "blur" }
          ],
          code: [{ validator: checkRoleCode, trigger: "change" }]
        }
      },
      isClipboardShow: false,
      clipboardList: [],
      expandedKeys: [],
      autoExpandParent: true,
      searchRoleValue: "",
      pids: {
        0: "无"
      },
      deviceTypeList: [],
      menusList: [],
      activeKeys: [],
      innerActiveKeys: [],
      isOutestAllSelected: false,
      form: {
        menus: [],
        pid: undefined,
        "zh-CN": "",
        privilegeLevel: "5",
        dataScope: undefined,
        allowSelectDeviceType: [],
        enabled: false,
        isSelfStation: false,
        userDataScope: 0
      },
      rules: {
        pid: [
          {
            required: true,
            message: "请选择父级角色"
          }
        ],
        "zh-CN": [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }
        ],
        privilegeLevel: [
          {
            required: true,
            message: "请输入权限等级",
            trigger: "blur"
          }
        ],
        dataScope: [
          {
            required: true,
            message: "请选择数据权限"
          }
        ]
      },
      isOutestindeterminate: false,
      environmentMap: ['PC', '移动', '移动和PC']
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        if (v === 'en') {
          this.rules.pid[0].message = 'Please select a parent role'
          this.rules['zh-CN'][0].message = 'Please enter role name'
          this.rules.privilegeLevel[0].message = 'Please enter privilege level'
          this.rules.dataScope[0].message = 'Please select data scope'
        }
        if (v === 'zh') {
          this.rules.pid[0].message = '请选择父级角色'
          this.rules['zh-CN'][0].message = '请输入角色名称'
          this.rules.privilegeLevel[0].message = '请输入权限等级'
          this.rules.dataScope[0].message = '请选择数据权限'
        }
      }
    }
  },
  methods: {
    getDictList() {
      getDict("zh-CN", "deviceType").then(({ data }) => {
        this.deviceTypeList = data.content;
      });
    },
    async getRoleInfo(id) {
      const { data } = await getRole(id);
      const menuMap = {};
      data.menus.forEach(m => {
        menuMap[m.id] = m.authorities;
      });
      for (let key in this.form) {
        this.form[key] = data[key]
      }
      data.details.forEach(d => {
        this.form[d.locale] = d.name
      })
      this.form.code = data.code
      this.form.pid = data.pid + ''
      this.form.dataScope = data.dataScope + ''
      this.form.allowSelectDeviceType = data.allowSelectDeviceType?.length ? data.allowSelectDeviceType.split(',') : []
      // this.menusList.forEach(m => {
      //   if (menuMap[m.id]) {
      //     let aa = 0;
      //     if (m.authorities && m.authorities.length) {
      //       m.authorities.forEach(a => {
      //         const i = menuMap[m.id].find(mm => mm.id === a.id);
      //         if (i) {
      //           aa++;
      //           a.checked = true;
      //         } else {
      //           a.checked = false;
      //         }
      //       });
      //     }
      //     if (m.children && m.children.length) {
      //       let c = 0;
      //       m.children.forEach(a => {
      //         if (menuMap[a.id]) {
      //           if (a.authorities && a.authorities.length) {
      //             let count = 0;
      //             a.authorities.forEach(aa => {
      //               const i = menuMap[a.id].find(aaa => aaa.id === aa.id);
      //               if (i) {
      //                 aa.checked = true;
      //                 count++;
      //               } else {
      //                 aa.checked = false;
      //               }
      //             });
      //             if (count === a.authorities.length) {
      //               a.checked = true;
      //               a.indeterminate = false
      //               c++;
      //             } else if (count === 0) {
      //               a.indeterminate = false
      //               a.checked = false
      //             } else {
      //               a.indeterminate = true
      //               a.checked = false;
      //             }
      //           }
      //         }
      //       });
      //       if (c === 0) {
      //         m.indeterminate = false
      //         m.checked = false
      //       } else if (c === m.children.length) {
      //         m.indeterminate = false
      //         m.checked = true;
      //       } else {
      //         m.indeterminate = true
      //         m.checked = false;
      //       }
      //     } else if (aa === m.authorities.length) {
      //       m.checked = true;
      //       m.indeterminate = false
      //     } else if (aa === 0) {
      //       m.indeterminate = false
      //       m.checked = false;
      //     } else {
      //       m.indeterminate = true
      //       m.checked = false
      //     }
      //   }
      // })
      // this.isOutestAllSelected = !this.menusList.find(m => !m.checked);
      let cc = 0;
      let ic = 0;
      for (let i = 0; i < this.menusList.length; i++) {
        const m = this.menusList[i];
        if (menuMap[m.id]) {
          if (m.authorities && m.authorities.length) {
            let c = 0;
            m.authorities.forEach(a => {
              if (menuMap[m.id].find(au => au.id === a.id)) {
                a.checked = true;
                c++;
              } else {
                a.checked = false;
              }
            });
            if (c === 0) {
              m.checked = false;
              m.indeterminate = false;
            } else if (c === m.authorities.length) {
              m.checked = true;
              m.indeterminate = false;
            } else {
              m.checked = false;
              m.indeterminate = true;
            }
          } else if (m.children && m.children.length) {
            let cc = 0;
            let ic = 0;
            m.children.forEach(c => {
              if (menuMap[c.id]) {
                if (c.authorities && c.authorities.length) {
                  let cCount = 0;
                  c.authorities.forEach(ca => {
                    if (menuMap[c.id].find(au => au.id === ca.id)) {
                      ca.checked = true;
                      cCount++;
                    }
                  });
                  if (cCount === 0) {
                    c.indeterminate = false;
                    c.checked = false;
                  } else if (cCount === c.authorities.length) {
                    c.indeterminate = false;
                    c.checked = true;
                    cc++;
                  } else {
                    c.indeterminate = true;
                    c.checked = false;
                    ic++;
                  }
                } else {
                  console.log(c);
                  if (menuMap[c.id]) {
                    c.checked = true
                    cc++
                  }
                }
              }
            });
            if (cc === m.children.length) {
              m.checked = true;
              m.indeterminate = false;
            } else if (ic + cc === 0) {
              m.checked = false;
              m.indeterminate = false;
            } else {
              m.checked = false;
              m.indeterminate = true;
            }
          } else {
            m.checked = true
          }
        }
        if (m.checked) {
          cc++;
        } else if (m.indeterminate) {
          ic++;
        }
      }
      if (cc === this.menusList.length) {
        this.isOutestAllSelected = true;
        this.isOutestindeterminate = false;
      } else if (cc + ic === 0) {
        this.isOutestAllSelected = false;
        this.isOutestindeterminate = false;
      } else {
        this.isOutestAllSelected = false;
        this.isOutestindeterminate = true;
      }
      this.$forceUpdate();
    },
    clickMenuItem({ key }) {
      this.currentRole = [key];
      this.getRolePermission();
    },
    handleSelfStationChange(e) {
      this.form.isSelfStation = e.target.checked
    },
    getRoleList() {
      return userApi
        .getRoleList()
        .then(({ data }) => {
          this.roleList = data;
          this.$forceUpdate();
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    getAllPermission() {
      return userApi
        .getAllPermission()
        .then(({ data }) => {
          this.permissionList = data;
          this.permissionList.forEach(item => {
            item.indeterminate = false;
            item.checkAll = false;
          });
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    async getAllMenuList() {
      const { data } = await getAllMenuList();
      this.menusList = data
      // this.m = data
      this.setMenuName(this.menusList);
    },
    setName(a) {
      a.forEach(o => {
        o.details.forEach(d => {
          o[d.locale] = d.name;
        });
        this.pids[o.id] = o["zh-CN"];
        if (o.children && o.children.length) {
          this.setName(o.children);
        }
      });
    },
    setMenuName(a) {
      a.forEach(o => {
        o.details.forEach(d => {
          o[d.locale] = d.name;
        });
        if (!o["zh-CN"]) {
          o["zh-CN"] = o["en-US"];
        }
        if (o.children && o.children.length) {
          this.setMenuName(o.children);
        } else {
          this.activeKeys.push(o.id + "");
        }
        if (o.authorities && o.authorities.length) {
          this.innerActiveKeys.push(o.id + "");
          this.setMenuName(o.authorities);
        }
      });
    },
    handleSelectAllOut(e) {
      this.isOutestindeterminate = false;
      this.outestBoolean = e.target.checked;
      this.setOutestMenuChecked(this.menusList);
      this.$forceUpdate();
    },
    handleOuterChange(e, m) {
      m.indeterminate = false;
      this.outestBoolean = e.target.checked;
      this.setOutestMenuChecked(m.children);
      this.setOutestMenuChecked(m.authorities);
      let count = 0;
      for (let i = 0; i < this.menusList.length; i++) {
        if (this.menusList[i].checked) {
          count++;
        }
      }
      if (count === 0) {
        this.isOutestindeterminate = false;
        this.isOutestAllSelected = false;
      } else if (count === this.menusList.length) {
        this.isOutestindeterminate = false;
        this.isOutestAllSelected = true;
      } else {
        this.isOutestindeterminate = true;
        this.isOutestAllSelected = false;
      }
      this.$forceUpdate();
    },
    handleChildrenMenuChange(e, m, om) {
      m.indeterminate = false;
      this.outestBoolean = e.target.checked;
      this.setOutestMenuChecked(m.children);
      this.setOutestMenuChecked(m.authorities);
      let cc = 0;
      let ic = 0;
      for (let i = 0; i < om.children.length; i++) {
        if (om.children[i].checked) {
          cc++;
        } else if (om.children[i].indeterminate) {
          ic++;
        }
      }
      if (cc + ic === 0) {
        om.indeterminate = false;
        om.checked = false;
      } else if (cc === om.children.length) {
        om.indeterminate = false;
        om.checked = true;
      } else {
        om.checked = false;
        om.indeterminate = true;
      }
      let count = 0;
      let iCount = 0;
      for (let i = 0; i < this.menusList.length; i++) {
        if (this.menusList[i].checked) {
          count++;
        } else if (this.menusList[i].indeterminate) {
          iCount++;
        }
      }
      if (count + iCount === 0) {
        this.isOutestindeterminate = false;
        this.isOutestAllSelected = false;
      } else if (count === this.menusList.length) {
        this.isOutestindeterminate = false;
        this.isOutestAllSelected = true;
      } else {
        this.isOutestindeterminate = true;
        this.isOutestAllSelected = false;
      }
      this.$forceUpdate();
    },
    handleAuthoritiesChange(...args) {
      args[1].checked = !args[1].authorities.find(a => !a.checked);
      let c = 0;
      for (let i = 0; i < args[1].authorities.length; i++) {
        if (args[1].authorities[i].checked) {
          c++;
        }
      }
      if (c === 0) {
        args[1].checked = false;
        args[1].indeterminate = false;
      } else if (c === args[1].authorities.length) {
        args[1].indeterminate = false;
        args[1].checked = true;
      } else {
        args[1].checked = false;
        args[1].indeterminate = true;
      }
      if (args.length === 3) {
        let cc = 0;
        let ic = 0;
        for (let i = 0; i < args[2].children.length; i++) {
          if (args[2].children[i].checked) {
            cc++;
          } else if (args[2].children[i].indeterminate) {
            ic++;
          }
        }
        if (cc + ic === 0) {
          args[2].checked = false;
          args[2].indeterminate = false;
        } else if (cc === args[2].children.length) {
          args[2].indeterminate = false;
          args[2].checked = true;
        } else {
          args[2].checked = false;
          args[2].indeterminate = true;
        }
      }
      let count = 0;
      let iCount = 0;
      for (let i = 0; i < this.menusList.length; i++) {
        if (this.menusList[i].checked) {
          count++;
        } else if (this.menusList[i].indeterminate) {
          iCount++;
        }
      }
      if (count + iCount === 0) {
        this.isOutestindeterminate = false;
        this.isOutestAllSelected = false;
      } else if (count === this.menusList.length) {
        this.isOutestindeterminate = false;
        this.isOutestAllSelected = true;
      } else {
        this.isOutestindeterminate = true;
        this.isOutestAllSelected = false;
      }
      this.$forceUpdate();
    },
    setOutestMenuChecked(a) {
      a.forEach(o => {
        o.indeterminate = false;
        o.checked = this.outestBoolean;
        if (o.children && o.children.length) {
          this.setOutestMenuChecked(o.children);
        }
        if (o.authorities && o.authorities.length) {
          this.setOutestMenuChecked(o.authorities);
        }
      });
    },
    saveRole() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const ml = []
          const checkMenu = a => {
            a.forEach(m => {
              // if (m.checked) {
              //   this.form.menus.push({
              //     id: m.id,
              //     authorities: m.authorities?.length > 0 ? m.authorities : []
              //   });
              // }
              // if (m.children && m.children.length > 0) {
              //   checkMenu(m.children)
              // }
              if (m.authorities && m.authorities.length) {
                let a = [];
                for (let i = 0; i < m.authorities.length; i++) {
                  if (m.authorities[i].checked) {
                    a.push({
                      id: m.authorities[i].id
                    });
                  }
                }
                if (a.length) {
                  ml.push({
                    id: m.id,
                    authorities: a
                  });
                }
              } else if (m.children && m.children.length) {
                let c = 0;
                for (let i = 0; i < m.children.length; i++) {
                  const item = m.children[i];
                  if (item.authorities && item.authorities.length) {
                    let a = [];
                    for (let j = 0; j < item.authorities.length; j++) {
                      if (item.authorities[j].checked) {
                        a.push({
                          id: item.authorities[j].id
                        });
                      }
                    }
                    if (a.length) {
                      c++;
                      ml.push({
                        id: item.id,
                        authorities: a
                      });
                    }
                  } else {
                    if (item.checked) {
                      ml.push({
                        id: item.id,
                        authorities: []
                      })
                      c++
                    }
                  }
                }
                if (c > 0) {
                  console.log(m.id, m);
                  ml.push({
                    id: m.id,
                    authorities: []
                  });
                }
              } else {
                if (m.checked) {
                  ml.push({
                    id: m.id,
                    authorities: []
                  })
                }
              }
            });
          };
          checkMenu(this.menusList);

          const form = {
            pid: +this.form.pid,
            code: this.form.code || "",
            details: [
              {
                locale: "zh-CN",
                name: this.form["zh-CN"],
                description: null
              },
              {
                locale: "en-US",
                name: this.form["en-US"] || "",
                description: null
              }
            ],
            dataScope: +this.form.dataScope,
            allowSelectDeviceType: this.form.allowSelectDeviceType + "",
            enabled: this.form.enabled,
            menus: ml,
            privilegeLevel: +this.form.privilegeLevel,
            isSelfStation: this.form.isSelfStation,
            userDataScope: this.form.userDataScope
          };
          if (this.$route.query.id) {
            form.id = +this.$route.query.id
            const { message } = await updateRole(form);
            this.$message.success(message);
          } else {
            const { message } = await addRole(form);
            this.$message.success(message);
          }
          console.log(form.menus);
          this.$router.back()
        }
      })
    },
    routeBack() {
      this.$router.back();
    },
    getRolePermission() {
      const check = (id, list) => {
        for (let i = 0; i < list.length; i++) {
          if (list[i].id === id) {
            return true;
          }
        }
        return false;
      };
      return userApi
        .getRolePermission(this.currentRole[0])
        .then(({ data }) => {
          this.selectedPermission = [];
          this.permissionList.forEach((item, index) => {
            data.forEach(({ id }) => {
              if (check(id, item.permissions)) {
                if (!this.selectedPermission[index]) {
                  this.selectedPermission[index] = [];
                }
                this.selectedPermission[index].push(id);
              }
            });
            if (!this.selectedPermission[index]) {
              this.selectedPermission[index] = [];
            }
            this.onChange(this.selectedPermission[index], item);
          });
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    deleteRole(roleId) {
      const _this = this;
      this.$Mconfirm({
        content: "确认删除所选角色？",
        onOk() {
          return new Promise((resolve, reject) => {
            return userApi
              .deleteRole(roleId)
              .then(() => _this.getRoleList())
              .then(() => resolve());
          });
        },
        onCancel() {}
      });
    },
    showRoleModal(role, idEdit) {
      this.roleModal.role = role;
      if (!this.roleModal.role.pid) {
        this.roleModal.role.pid = 0;
      }
      this.roleModal.visible = true;
    },
    onChange(checkedList, menu) {
      menu.indeterminate =
        !!checkedList.length && checkedList.length < menu.permissions.length;
      menu.checkAll = checkedList.length === menu.permissions.length;
    },
    onCheckAllChange(e, menu, index) {
      menu.checkAll = e.target.checked;
      if (menu.checkAll) {
        menu.indeterminate = false;
      }
      this.selectedPermission[index] = [];
      if (menu.checkAll) {
        menu.permissions.forEach(item => {
          this.selectedPermission[index].push(item.id);
        });
      }
      this.$forceUpdate();
    },
    saveRolePermission() {
      const permissionIds = [];
      this.selectedPermission.forEach(item => {
        if (item.length > 0) {
          item.forEach(id => {
            permissionIds.push(id);
          });
        }
      });
      userApi
        .updateRolePermission(this.currentRole[0], permissionIds)
        .then(() => {
          this.$message.success("保存成功");
        })
        .then(({ message }) => {
          this.$message.warning(message);
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    saveOrUpdateRole() {
      this.$refs.roleForm.validate(vaild => {
        if (vaild) {
          userApi
            .saveRole(this.roleModal.role)
            .then(() => {
              this.$message.success("提交成功");
              this.getRoleList();
            })
            .catch(({ message }) => {
              this.$message.warning(message);
            })
            .finally(() => {
              this.roleModal.visible = false;
            });
        }
      });
    },
    removeClip(r) {
      const index = this.clipboardList.findIndex(c => c.id === r.id)
      if (index > -1) {
        this.clipboardList.splice(index, 1)
        this.$store.commit('setClipboard', this.clipboardList)
      }
    },
    showClipboard() {
      this.clipboardList = this.$store.state.clipboard
      this.isClipboardShow = true
    },
    async importBasicInfo(item) {
      this.loading1 = true
      const role = await this.getRoleDetail(item.id)
      for (let key in this.form) {
        this.form[key] = role[key]
      }
      role.details.forEach(d => {
        this.form[d.locale] = d.name
      })
      this.form.code = item.code
      this.form.pid = role.pid + ''
      this.form.dataScope = role.dataScope + ''
      this.form.allowSelectDeviceType = role.allowSelectDeviceType?.length ? role.allowSelectDeviceType.split(',') : []
      this.loading1 = false
      this.isClipboardShow = false
    },
    async importAuth(item) {
      item.loading = true
      this.handleSelectAllOut({ target: { checked: false } })
      const menuMap = {}
      const role = await this.getRoleDetail(item.id)
      role.menus.forEach(m => {
        menuMap[m.id] = m.authorities;
      })
      let cc = 0;
      let ic = 0;
      for (let i = 0; i < this.menusList.length; i++) {
        const m = this.menusList[i];
        if (menuMap[m.id]) {
          if (m.authorities && m.authorities.length) {
            let c = 0;
            m.authorities.forEach(a => {
              if (menuMap[m.id].find(au => au.id === a.id)) {
                a.checked = true;
                c++;
              } else {
                a.checked = false;
              }
            });
            if (c === 0) {
              m.checked = false;
              m.indeterminate = false;
            } else if (c === m.authorities.length) {
              m.checked = true;
              m.indeterminate = false;
            } else {
              m.checked = false;
              m.indeterminate = true;
            }
          } else if (m.children && m.children.length) {
            let cc = 0;
            let ic = 0;
            m.children.forEach(c => {
              if (menuMap[c.id]) {
                if (c.authorities && c.authorities.length) {
                  let cCount = 0;
                  c.authorities.forEach(ca => {
                    if (menuMap[c.id].find(au => au.id === ca.id)) {
                      ca.checked = true;
                      cCount++;
                    }
                  });
                  if (cCount === 0) {
                    c.indeterminate = false;
                    c.checked = false;
                  } else if (cCount === c.authorities.length) {
                    c.indeterminate = false;
                    c.checked = true;
                    cc++;
                  } else {
                    c.indeterminate = true;
                    c.checked = false;
                    ic++;
                  }
                } else {
                  console.log(c);
                  if (menuMap[c.id]) {
                    c.checked = true
                    cc++
                  }
                }
              }
            });
            if (cc === m.children.length) {
              m.checked = true;
              m.indeterminate = false;
            } else if (ic + cc === 0) {
              m.checked = false;
              m.indeterminate = false;
            } else {
              m.checked = false;
              m.indeterminate = true;
            }
          } else {
            m.checked = true
          }
        }
        if (m.checked) {
          cc++;
        } else if (m.indeterminate) {
          ic++;
        }
      }
      if (cc === this.menusList.length) {
        this.isOutestAllSelected = true;
        this.isOutestindeterminate = false;
      } else if (cc + ic === 0) {
        this.isOutestAllSelected = false;
        this.isOutestindeterminate = false;
      } else {
        this.isOutestAllSelected = false;
        this.isOutestindeterminate = true;
      }
      this.$forceUpdate();
      item.loading = false
      this.isClipboardShow = false
    },
    async importAll(item) {
      this.loading3 = true
      await this.getRoleInfo(item.id)
      this.loading3 = false
      this.isClipboardShow = false
    },
    async getRoleDetail(id) {
      try {
        const { data } = await getRole(id)
        return data
      } catch {
        return this.form
      }
    }
  }
};
</script>

<style lang="less" scoped>
.h-100 {
  height: 100%;
}
.bg-white {
  background-color: #fff;
}
.role-item-option {
  float: right;
  display: none;
}
.role-item:hover {
  .role-item-option {
    display: inline-block;
  }
}
.role-item:active {
  .role-item-option {
    display: inline-block;
  }
}
/deep/ .ant-collapse-header {
  background-color: #fff;
}
/deep/ .ant-collapse {
  .ant-collapse-item {
    border: none;
  }
  border: none;
}
/deep/ .ant-collapse-content {
  border-top: 1px solid #f0f1f5;
}
</style>
